import moment from "moment/min/moment-with-locales";

import { DateFormats } from "@enums/shared.enum";

export const formatDeviceId = (value: string) => {
  // Remove all non-alphanumeric characters
  const cleaned = value.replace(/[^A-Za-z0-9]/g, "");

  // Apply mask: XXXX-XXXX-XXXX (4-4-4, 12 chars)
  let formatted = "";
  for (let i = 0; i < cleaned.length && i < 12; i++) {
    if (i === 4 || i === 8) {
      formatted += "-";
    }
    formatted += cleaned[i];
  }

  return formatted;
};

export const formatDateTime = (
  date: Date,
  selectedLanguage: string
): string => {
  return moment(date).locale(selectedLanguage).format(DateFormats.DateTime);
};
